import { g as r } from "../internals/global.js";
import { f as t } from "../internals/function-apply.js";
import { a } from "../internals/array-buffer-view-core.js";
import { f as o } from "../internals/fails.js";
import { a as n } from "../internals/array-slice.js";
var i = r.Int8Array,
  e = a.aTypedArray,
  l = a.exportTypedArrayMethod,
  s = [].toLocaleString,
  f = !!i && o(function () {
    s.call(new i(1));
  });
l("toLocaleString", function () {
  return t(s, f ? n(e(this)) : e(this), n(arguments));
}, o(function () {
  return [1, 2].toLocaleString() != new i([1, 2]).toLocaleString();
}) || !o(function () {
  i.prototype.toLocaleString.call([1, 2]);
}));